import { gql } from 'graphql-tag';

export const GET_ACCOUNT_SETTINGS = gql`
  query accountSettings($id: Float) {
    accountSettings(where: { id: { eq: $id } }) {
      id
      l7 {
        analyzer
        l7Incidents
        l7Limit
        trialPeriod
        l7Events
        visibility
      }
      dns {
        recordLimit
        resourceLimit
      }
      partnerClientAccountId
    }
  }
`;

export const GET_NETWORK_PROTECTION_SETTINGS = gql`
  query GET_NETWORK_PROTECTION_SETTINGS($id: Float) {
    accountSettings(where: { partnerClientAccountId: { eq: $id } }) {
      id
      networkProtection {
        visibility
        trialPeriod
      }
      partnerClientAccountId
    }
  }
`;

export const GET_PARTNER_ACCOUNT_EMPLOYEE = gql`
  query partnerAccountEmployee($id: [Int!]) {
    partnerAccountEmployee(where: { id: { in: $id } }) {
      id
      email
      name {
        first
        last
      }
      role
      notificationSubscribe {
        channel
        trigger
      }
      partnerAccountId
      lang
    }
  }
`;

export const GET_PARTNER_ACCOUNT_EMPLOYEES = gql`
  query partnerAccountEmployees($limit: Float, $page: Float, $id: [Int!]) {
    partnerAccountEmployees(
      paginate: { limit: $limit, page: $page }
      order: { id: DESC }
      where: { id: { in: $id } }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        status
        id
        email
        name {
          first
          last
        }
        role
        notificationSubscribe {
          channel
          trigger
        }
        partnerAccountId
        createdAt
        deletedAt
      }
    }
  }
`;

export const GET_PARTNER_CLIENT_ACCOUNTS = gql`
  query partnerClientAccounts(
    $limit: Float
    $page: Float
    $filterId: [Int!]
    $filterName: String
    $deletedAt: Date
    $sortId: OrderEnum
  ) {
    partnerClientAccounts(
      paginate: { limit: $limit, page: $page }
      where: {
        id: { in: $filterId }
        name: { contain: $filterName }
        deletedAt: { eq: $deletedAt }
      }
      order: { id: $sortId }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        createdAt
        deletedAt
        name
        partnerClientAccountEmployees {
          id
          email
          deletedAt
          status
          isInDefaultGroup
        }
        accountStatus
        productStatus {
          applicationProtection
          dnsHosting
          networkProtectionV2
        }
      }
    }
  }
`;

export const GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEES = gql`
  query partnerClientAccountEmployees(
    $limit: Float
    $page: Float
    $filterId: [Int!]
    $filterPartnerClientAccountId: Float
    $filterEmail: String
    $sortId: OrderEnum
    $sortStatus: OrderEnum
    $deletedAt: Date
  ) {
    partnerClientAccountEmployees(
      paginate: { limit: $limit, page: $page }
      order: { id: $sortId, status: $sortStatus }
      where: {
        id: { in: $filterId }
        partnerClientAccountId: { eq: $filterPartnerClientAccountId }
        email: { contain: $filterEmail }
        deletedAt: { eq: $deletedAt }
      }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        createdAt
        deletedAt
        email
        id
        lang
        authenticationType
        name {
          first
          last
        }
        notificationSubscribe {
          channel
          trigger
        }
        partnerClientAccountId
        phone
        groups {
          id
          name
          description
          role
        }
        status
        updatedAt
        isInDefaultGroup
      }
    }
  }
`;

export const GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEES_NEW = gql`
  query GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEES_NEW(
    $pageSize: Float
    $page: Float
    $filterEmail: String
    $filterId: [Int!]
    $partnerClientAccountId: [Int!]
    $sortId: OrderEnum
    $sortStatus: OrderEnum
    $deletedAt: Date
  ) {
    partnerClientAccountEmployees(
      paginate: { limit: $pageSize, page: $page }
      where: {
        id: { in: $filterId }
        email: { contain: $filterEmail }
        partnerClientAccountId: { in: $partnerClientAccountId }
        deletedAt: { eq: $deletedAt }
      }
      order: { id: $sortId, status: $sortStatus }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        email
        name {
          first
          last
        }
        createdAt
        deletedAt
        partnerClientAccountId
        status
        authenticationType
        isInDefaultGroup
        groups {
          id
          name
        }
      }
    }
  }
`;

export const GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEE = gql`
  query GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEE($id: [Int!]) {
    partnerClientAccountEmployee(where: { id: { in: $id } }) {
      id
      email
      name {
        first
        last
      }
      status
      authenticationType
      createdAt
      deletedAt
      partnerClientAccountId
      lang
      availableLangs
      restLimit
      restTtl
    }
  }
`;

export const GET_DEFAULT_GROUPS = gql`
  query defaultGroups(
    $page: Float
    $limit: Float
    $filterPartnerClientAccountEmployee: String
    $deletedAt: Date
    $sortId: OrderEnum
    $partnerClientAccountId: Float
    $sortPartnerClientAccountEmployeeId: OrderEnum
  ) {
    defaultGroups(
      paginate: { page: $page, limit: $limit }
      where: {
        partnerClientAccountEmployee: { email: { contain: $filterPartnerClientAccountEmployee } }
        deletedAt: { eq: $deletedAt }
        partnerClientAccountId: { eq: $partnerClientAccountId }
      }
      order: { id: $sortId, partnerClientAccountEmployeeId: $sortPartnerClientAccountEmployeeId }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        partnerClientAccountEmployee {
          name {
            first
            last
          }
          authenticationType
          partnerClientAccountId
          status
          email
        }
        partnerClientAccountEmployeeId
        partnerClientAccountId
      }
    }
  }
`;

export const GET_ACCESS_GROUPS = gql`
  query accessGroups(
    $limit: Float
    $page: Float
    $filterPartnerClientAccountId: Float
    $filterName: String
    $sortId: OrderEnum
    $sortRole: OrderEnum
    $sortName: OrderEnum
    $sortUpdatedAt: OrderEnum
    $filterId: Float
    $filterRole: String
    $deletedAt: Date
  ) {
    accessGroups(
      paginate: { limit: $limit, page: $page }
      where: {
        id: { eq: $filterId }
        partnerClientAccountId: { eq: $filterPartnerClientAccountId }
        name: { contain: $filterName }
        role: { eq: $filterRole }
        deletedAt: { eq: $deletedAt }
      }
      order: { id: $sortId, role: $sortRole, name: $sortName, updatedAt: $sortUpdatedAt }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        partnerClientAccountId
        createdAt
        name
        description
        id
        resourceSets {
          resourceType
          count
        }
        role
        usersCount
        updatedAt
      }
    }
  }
`;

export const GET_ACCESS_GROUP_EMPLOYEES = gql`
  query accessGroupEmployees(
    $filterAccessGroupsName: String
    $filterAccessGroupsRole: GroupRoleEnum
    $filterUserEmail: String
    $pageSize: Float!
    $page: Float!
    $userId: Float
    $accessGroupId: Float
    $sortId: OrderEnum
    $deletedAt: Date
  ) {
    accessGroupEmployees(
      where: {
        accessGroupRole: $filterAccessGroupsRole
        accessGroupName: { contain: $filterAccessGroupsName }
        partnerClientAccountEmployeeId: { eq: $userId }
        accessGroupId: { eq: $accessGroupId }
        partnerClientAccountEmployee: { email: { contain: $filterUserEmail } }
        deletedAt: { eq: $deletedAt }
      }
      paginate: { limit: $pageSize, page: $page }
      order: { partnerClientAccountEmployeeId: $sortId }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        accessGroupDescription
        accessGroupId
        accessGroupName
        accessGroupRole
        createdAt
        groupsCount
        id
        partnerClientAccountEmployee {
          id
          name {
            first
            last
          }
          email
        }
        partnerClientAccountEmployeeId
        updatedAt
      }
    }
  }
`;

export const GET_ACCESS_GROUP_RESOURCES = gql`
  query accessGroupResources(
    $limit: Float
    $page: Float
    $filterAccessGroupId: Float
    $filterResourceType: AccessGroupResourceType
    $filterResourceName: String
    $filterL3ProtectedProfileName: String
    $filterL7ResourceName: String
    $filterDnsRemoteName: String
    $filterDnsAclName: String
    $sortResourceId: OrderEnum
    $filterResourceId: String
    $deletedAt: Date
  ) {
    accessGroupResources(
      paginate: { limit: $limit, page: $page }
      where: {
        accessGroupId: { eq: $filterAccessGroupId }
        resourceType: $filterResourceType
        resourceNames: {
          l3MonitoringObjectName: { contain: $filterResourceName }
          l3ProtectedProfileName: { contain: $filterL3ProtectedProfileName }
          l7ResourceName: { contain: $filterL7ResourceName }
          dnsRemoteName: { contain: $filterDnsRemoteName }
          dnsResourceZone: { contain: $filterResourceId }
          dnsAclName: { contain: $filterDnsAclName }
        }
        deletedAt: { eq: $deletedAt }
      }
      order: { resourceId: $sortResourceId }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        resourceId
        resourceName
        resourceType
        accessGroupId
      }
    }
  }
`;
//
export const GET_DNS_ZONES = gql`
  query dnsResources(
    $limit: Float
    $page: Float
    $sortId: OrderEnum = DESC
    $sortZone: OrderEnum
    $id: [Int!]
    $zone: String
    $deletedAtEq: Date
    $deletedAtNeq: Date
    $delegated: String
    $partnerClientAccountId: Float
    $remoteIdEq: Float
    $remoteIdNeq: Float
  ) {
    dnsResources(
      paginate: { limit: $limit, page: $page }
      where: {
        id: { in: $id }
        zone: { contain: $zone }
        deletedAt: { eq: $deletedAtEq, neq: $deletedAtNeq }
        partnerClientAccountId: { eq: $partnerClientAccountId }
        delegated: { eq: $delegated }
        remoteId: { eq: $remoteIdEq, neq: $remoteIdNeq }
      }
      order: { id: $sortId, zone: $sortZone }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        zone
        partnerClientAccountId
        createdAt
        updatedAt
        deletedAt
        delegated
        remoteId
        aclId
      }
    }
  }
`;

export const GET_MONITORING_OBJECTS = gql`
  query GET_MONITORING_OBJECTS(
    $pageSize: Float
    $page: Float
    $sortId: OrderEnum
    $sortCreatedAt: OrderEnum
    $filterId: [Int!]
    $filterName: String
    $filterMonitoringObjectName: String
    $deletedAt: Date
    $filterPartnerClientAccountId: Float
  ) {
    l3MonitoringObjects(
      paginate: { limit: $pageSize, page: $page }
      where: {
        deletedAt: { eq: $deletedAt }
        id: { in: $filterId }
        name: { contain: $filterName }
        monitoringObjectName: { contain: $filterMonitoringObjectName }
        partnerClientAccountId: { eq: $filterPartnerClientAccountId }
      }
      order: { id: $sortId, createdAt: $sortCreatedAt }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        ips
        name
        description
        monitoringObjectName
        partnerClientAccountId
      }
    }
  }
`;

export const GET_PROTECTED_PROFILES = gql`
  query GET_PROTECTED_PROFILES(
    $pageSize: Float
    $page: Float
    $sortId: OrderEnum
    $sortCreatedAt: OrderEnum
    $filterId: [Int!]
    $filterName: String
    $filterProfileName: String
    $deletedAt: Date
    $filterPartnerClientAccountId: Float
  ) {
    l3ProtectedProfiles(
      paginate: { limit: $pageSize, page: $page }
      where: {
        id: { in: $filterId }
        name: { contain: $filterName }
        profileName: { contain: $filterProfileName }
        deletedAt: { eq: $deletedAt }
        partnerClientAccountId: { eq: $filterPartnerClientAccountId }
      }
      order: { id: $sortId, createdAt: $sortCreatedAt }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        createdAt
        updatedAt
        deletedAt
        ips
        name
        description
        profileName
        partnerClientAccountId
      }
    }
  }
`;

export const DNS_REMOTES_DOCUMENT = gql`
  query dnsRemotes(
    $page: Float
    $limit: Float
    $id: Float
    $name: String
    $sortId: OrderEnum = DESC
    $partnerClientAccountId: [Int!]
    $deletedAtEq: Date
    $deletedAtNeq: Date
  ) {
    dnsRemotes(
      paginate: { page: $page, limit: $limit }
      where: {
        id: { eq: $id }
        name: { contain: $name }
        deletedAt: { eq: $deletedAtEq, neq: $deletedAtNeq }
        partnerClientAccountId: { in: $partnerClientAccountId }
      }
      order: { id: $sortId }
    ) {
      info {
        totalPages
        page
        limit
        totalCount
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        name
        address
        updatedAt
        createdAt
        dnsResources {
          zone
        }
      }
    }
  }
`;

export const DNS_ACLS_DOCUMENT = gql`
  query dnsAcls(
    $page: Float
    $limit: Float
    $filterId: Float
    $filterName: String
    $deletedAtEq: Date
    $deletedAtNeq: Date
    $sortId: OrderEnum
    $partnerClientAccountId: [Int!]
  ) {
    dnsAcls(
      paginate: { page: $page, limit: $limit }
      where: {
        id: { eq: $filterId }
        name: { contain: $filterName }
        deletedAt: { eq: $deletedAtEq, neq: $deletedAtNeq }
        partnerClientAccountId: { in: $partnerClientAccountId }
      }
      order: { id: $sortId }
    ) {
      info {
        totalPages
        page
        limit
        totalCount
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        name
        address
        updatedAt
        createdAt
        dnsResources {
          zone
        }
      }
    }
  }
`;

export const GET_L7_RESOURCES = gql`
  query l7Resources(
    $limit: Float
    $page: Float
    $l7ResourceId: Float
    $l7ResourceName: String
    $serviceIp: String
    $deletedAt: Date
    $sortL7ResourceId: OrderEnum
    $sortL7ResourceName: OrderEnum
    $partnerClientAccountId: Float
  ) {
    l7Resources(
      paginate: { limit: $limit, page: $page }
      order: { l7ResourceId: $sortL7ResourceId, l7ResourceName: $sortL7ResourceName }
      where: {
        l7ResourceId: { eq: $l7ResourceId }
        l7ResourceName: { contain: $l7ResourceName }
        protectedIp: { contain: $serviceIp }
        deletedAt: { eq: $deletedAt }
        partnerClientAccountId: { eq: $partnerClientAccountId }
      }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        active
        l7Protection
        advancedProtection
        botAnalytics
        botProtection
        createdAt
        deletedAt
        externalNginx
        id
        isBotProfile
        l7ResourceId
        l7ResourceName
        partnerClientAccountId
        passLabelToUpstream
        protectionDisabled
        protectionMode
        serviceCreated
        serviceEnable
        serviceExternalNginx
        serviceForcessl
        serviceGeoipList
        serviceGeoipMode
        serviceGlobalWhitelist
        serviceGrpc
        serviceHttp2
        serviceHttp2https
        serviceHttps2http
        serviceId
        serviceIp
        serviceModified
        serviceName
        serviceSsl
        serviceSslAuto
        serviceSslExpire
        serviceStream
        serviceWaf
        serviceWafMode
        serviceWwwredir
        updatedAt
        protectedIp
      }
    }
  }
`;

export const GET_L7_RESOURCES_VENDOR = gql`
  query l7ResourcesVendor(
    $limit: Float
    $page: Float
    $l7ResourceId: [Int!]
    $l7ResourceName: String
    $serviceIp: String
    $deletedAt: Date
    $sortL7ResourceId: OrderEnum
    $sortPartnerClientAccountId: OrderEnum
    $sortCreatedAt: OrderEnum
    $partnerClientAccountId: Float
  ) {
    l7ResourcesVendor(
      paginate: { limit: $limit, page: $page }
      order: {
        l7ResourceId: $sortL7ResourceId
        partnerClientAccountId: $sortPartnerClientAccountId
        createdAt: $sortCreatedAt
      }
      where: {
        l7ResourceId: { in: $l7ResourceId }
        l7ResourceName: { contain: $l7ResourceName }
        serviceIp: { contain: $serviceIp }
        deletedAt: { eq: $deletedAt }
        partnerClientAccountId: { eq: $partnerClientAccountId }
      }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        botAnalytics
        botProtection
        createdAt
        deletedAt
        externalNginx
        id
        isBotProfile
        l7ResourceId
        l7ResourceName
        partnerClientAccountId
        passLabelToUpstream
        protectionDisabled
        protectionMode
        serviceCreated
        serviceEnable
        serviceExternalNginx
        serviceForcessl
        serviceGeoipList
        serviceGeoipMode
        serviceGlobalWhitelist
        serviceGrpc
        serviceHttp2
        serviceHttp2https
        serviceHttps2http
        serviceId
        serviceIp
        serviceModified
        serviceName
        serviceSsl
        serviceSslAuto
        serviceSslExpire
        serviceStream
        serviceWaf
        serviceWafMode
        serviceWwwredir
        updatedAt
      }
    }
  }
`;

export const GET_ARBOR_RESOURCES = gql`
  query arborResources(
    $limit: Float
    $page: Float
    $name: String
    $id: [Int!]
    $partnerClientAccountId: [Int!]
    $deletedAt: Date
    $sortId: OrderEnum
    $sortAccountId: OrderEnum
    $sortCreatedAt: OrderEnum
  ) {
    arborResources(
      paginate: { limit: $limit, page: $page }
      where: {
        id: { in: $id }
        name: { contain: $name }
        partnerClientAccountId: { in: $partnerClientAccountId }
        deletedAt: { eq: $deletedAt }
      }
      order: { id: $sortId, partnerClientAccountId: $sortAccountId, createdAt: $sortCreatedAt }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        ips
        name
        createdAt
        partnerClientAccountId
        deletedAt
      }
    }
  }
`;

export const GET_ARBOR_ALERTS = gql`
  query arborAlerts(
    $limit: Float
    $page: Float
    $importance: [String!]
    $id: [Int!]
    $detailsId: Float
    $ips: String
    $gte: Date
    $lte: Date
    $sortId: OrderEnum
    $sortDuration: OrderEnum
    $sortStart: OrderEnum
    $sortStop: OrderEnum
    $sortBps: OrderEnum
    $sortPps: OrderEnum
    $ongoing: String
  ) {
    arborAlerts(
      paginate: { limit: $limit, page: $page }
      where: {
        importance: { in: $importance }
        alertId: { in: $id, eq: $detailsId }
        alertResourceCidr: { contain: $ips }
        start: { gte: $gte, lte: $lte }
        ongoing: { eq: $ongoing }
      }
      order: {
        alertId: $sortId
        duration: $sortDuration
        start: $sortStart
        stop: $sortStop
        maxImpactBps: $sortBps
        maxImpactPps: $sortPps
      }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        alertResourceCidr
        arborResource {
          name
        }
        alertManagedObjectName
        alertResourceCidr
        alertId
        direction
        duration
        host
        id
        importance
        misuseTypes
        maxImpactBps
        maxImpactPps
        start
        stop
        type
        severityPercent
        threshold
        impactBpsPoints
        impactPpsPoints
        unit
        impactRecorded
      }
    }
  }
`;

export const GET_ARBOR_ALERT_DETAIL = gql`
  query arborAlertDetail($id: Float!) {
    arborAlertDetail(id: $id) {
      id
      arborAlertId
      protos_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      src_addr_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      src_addr_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      dest_addr_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      dest_addr_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      src_tcp_ports_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      src_tcp_ports_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      dest_tcp_ports_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      dest_tcp_ports_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      src_udp_ports_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      src_udp_ports_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      dest_udp_ports_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      dest_udp_ports_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      src_asn_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      src_asn_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      tcp_flags_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
      }
      tcp_flags_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      misuse_types_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
        sample_bytes
      }
      misuse_types_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
        sample_packets
      }
      packet_distribution {
        avg
        type
        sample
      }
      protos_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
      }
      src_countries_bytes {
        avg_bytes
        id_bytes
        max_bytes
        name_bytes
        country_bytes
        country_code_bytes
      }
      src_countries_packets {
        avg_packets
        id_packets
        max_packets
        name_packets
        country_packets
        country_code_packets
      }
      top_patterns_bytes {
        avg_bytes
        dest_ip_bytes
        dest_port_bytes
        max_bytes
        name_bytes
        src_port_bytes
        source_ip_bytes
        src_protocol_bytes
      }
      top_patterns_packets {
        avg_packets
        dest_ip_packets
        dest_port_packets
        max_packets
        name_packets
        src_port_packets
        source_ip_packets
        src_protocol_packets
      }
    }
  }
`;

export const GET_ARBOR_MITIGATIONS = gql`
  query arborMitigations(
    $limit: Float
    $page: Float
    $prefix: String
    $gte: Date
    $lte: Date
    $name: String
    $mitigationId: [Int!]
    $arborAlertId: [Int!]
    $ongoing: String
    $sortMitigationId: OrderEnum
    $sortAnomalyId: OrderEnum
    $sortDuration: OrderEnum
    $sortStart: OrderEnum
    $sortStop: OrderEnum
    $id: Float
  ) {
    arborMitigations(
      paginate: { limit: $limit, page: $page }
      order: {
        duration: $sortDuration
        start: $sortStart
        stop: $sortStop
        mitigationId: $sortMitigationId
        arborAlertId: $sortAnomalyId
      }
      where: {
        mitigationId: { in: $mitigationId }
        arborAlertId: { in: $arborAlertId }
        prefix: { contain: $prefix }
        start: { gte: $gte, lte: $lte }
        managedObjectName: { contain: $name }
        ongoing: { eq: $ongoing }
        id: { eq: $id }
      }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        mitigationId
        arborAlertId
        start
        stop
        prefix
        managedObjectName
        duration
      }
    }
  }
`;

export const GET_PARTNER_CLIENT_ACCOUNT = gql`
  query partnerClientAccount($id: [Int!]) {
    partnerClientAccount(where: { id: { in: $id } }) {
      id
      name
      accountSettings {
        id
        l7 {
          l7Limit
        }
        dosGate {
          dosGateLimit
        }
      }
    }
  }
`;

export const GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEES_ACCESS = gql`
  query partnerClientAccountEmployeeAccess($partnerClientAccountEmployeeId: [Int!]) {
    partnerClientAccountEmployeeAccess(
      where: { partnerClientAccountEmployeeId: { in: $partnerClientAccountEmployeeId } }
    ) {
      partnerClientAccountEmployeeId
      id
      l3Delete
      l3Read
      l3Update
      l7Delete
      l7Read
      l7Update
      create
    }
  }
`;

export const GET_L3_MONITORING_OBJECT = gql`
  query L3MonitoringObjects(
    $pageSize: Float
    $page: Float
    $sortId: OrderEnum
    $sortCreatedAt: OrderEnum
    $filterId: [Int!]
    $filterName: String
    $filterMonitoringObjectName: String
    $deletedAt: Date
    $filterPartnerClientAccountId: Float
  ) {
    l3MonitoringObjects(
      paginate: { limit: $pageSize, page: $page }
      where: {
        deletedAt: { eq: $deletedAt }
        id: { in: $filterId }
        name: { contain: $filterName }
        monitoringObjectName: { contain: $filterMonitoringObjectName }
        partnerClientAccountId: { eq: $filterPartnerClientAccountId }
      }
      order: { id: $sortId, createdAt: $sortCreatedAt }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        createdAt
        deletedAt
        ips
        name
        description
        monitoringObjectName
        partnerClientAccountId
        partnerClientAccount {
          partnerAccount {
            name
            id
          }
        }
      }
    }
  }
`;

export const GET_L3_PROTECTED_PROFILES = gql`
  query L3ProtectedProfiles(
    $pageSize: Float
    $page: Float
    $sortId: OrderEnum
    $sortCreatedAt: OrderEnum
    $filterId: [Int!]
    $filterName: String
    $filterProfileName: String
    $deletedAt: Date
    $filterPartnerClientAccountId: Float
  ) {
    l3ProtectedProfiles(
      paginate: { limit: $pageSize, page: $page }
      where: {
        id: { in: $filterId }
        name: { contain: $filterName }
        profileName: { contain: $filterProfileName }
        deletedAt: { eq: $deletedAt }
        partnerClientAccountId: { eq: $filterPartnerClientAccountId }
      }
      order: { id: $sortId, createdAt: $sortCreatedAt }
    ) {
      info {
        hasNextPage
        hasPreviousPage
        limit
        nextPage
        page
        previousPage
        totalCount
        totalPages
      }
      items {
        id
        createdAt
        deletedAt
        ips
        name
        description
        profileName
        partnerClientAccountId
        partnerClientAccount {
          partnerAccount {
            name
            id
          }
        }
      }
    }
  }
`;

export const GET_INVITATION_LINK = gql`
  query getInvitationLink($partnerClientAccountEmployeeId: Float!) {
    getInvitationLink(input: { partnerClientAccountEmployeeId: $partnerClientAccountEmployeeId }) {
      invitationLink
    }
  }
`;

export const GET_MITIGATION_STATISTIC = gql`
  query arborMitigationStatistic($arborMitigationId: Float!) {
    arborMitigationStatistic(arborMitigationId: $arborMitigationId) {
      ratesTotal {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesHttp {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesFilter {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesProtocolBaseline {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesSource24Baseline {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesSynAuth {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesDnsAuth {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesDnsMalformed {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesHttpRegex {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesDnsRegex {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesIdleReset {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesHttpMalformed {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesSipRatelimit {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesSipMalformed {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesZombie {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesRatelimit {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesRegex {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesInvalidPkts {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesDnsRatelimit {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesDnsNxRatelimit {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesGeoipFilter {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesGeoipRatelimit {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesSrcnetFilter {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
      ratesConnlimit {
        pass_bps
        pass_pps
        drop_bps
        drop_pps
      }
    }
  }
`;

export const GET_QR_CODE = gql`
  mutation activateTwoFactorAuth {
    activateTwoFactorAuth {
      qrCode
    }
  }
`;
